import { Link } from 'react-router-dom'
import { LEARN_PAGES } from '@/pages/learn/LearnLayout'

export default function ConditionTeasers() {
  return (
    <section className="condition-teasers" id="conditions">
      <div className="section-container">
        <div className="condition-teasers-header">
          <div className="section-label reveal">Understand your condition</div>
          <h2 className="section-title reveal reveal-delay-1">
            The science, in <em>plain language.</em>
          </h2>
          <p className="section-desc reveal reveal-delay-2">
            We actually understand a lot about these conditions. The treatments exist. Most women
            are just never told about them. Start here.
          </p>
        </div>

        <div className="condition-teasers-grid">
          {LEARN_PAGES.map((p, i) => (
            <Link
              key={p.slug}
              to={p.path}
              className={`condition-card reveal${i % 2 === 1 ? ' reveal-delay-1' : ''}`}
            >
              <span className="condition-card-eyebrow">{p.eyebrow}</span>
              <h3 className="condition-card-title">{p.shortTitle}</h3>
              <p className="condition-card-body">{p.oneLiner}</p>
              <span className="condition-card-cta">
                Read the full explainer
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
